export { initialImageCarouselState } from './initialState';



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/store/middleware/index.js